import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Checkbox, FormControlLabel, Typography } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/styles';

import { corrChartColors } from '../enhancedFeatures/clusterColors';


const ClusterViewSelector = props => {
  const { clusterMapView, clustersVisible, setClustersVisible } = props;

  const FCLabel = withStyles({
    root: {
      height: '25px',
    },
  })(FormControlLabel);

  const useStyles = makeStyles(() => ({
    wrapperDiv: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      paddingLeft: '7px',
      marginTop: '0.8em',
      paddingTop: '10px',
      borderTop: 'solid #EEE 1px',
    },
    chartStyleList: {
      paddingLeft: '100px',
      paddingTop: '40px',
      flexDirection: 'column !important',
    },
    paragraphStyle: {
      fontSize: '10px',
      fontWeight: 400,
      lineHeight: '12px',
    },
    formControlLabel: {
      fontWeight: 'bold',
    }
  }));

  const classes = useStyles();

  const handleCBChange = e => {
    const i = e.target.value;
    const cVisibles = [...clustersVisible];
    cVisibles[i] = !cVisibles[i];
    setClustersVisible(cVisibles);
  };

  return (
    <div className={classes.wrapperDiv}>
      <p className={classes.paragraphStyle}>
        Check the box to hide and show each cluster in the map.
      </p>
      <div className="scatter-checkboxes">
        <Grid container justify="flex-start" spacing={0}>
          {clustersVisible.map((x, tt) => (
            <div key={`cvs_${tt}`}>
              <Grid item>
                <FCLabel
                  control={
                    <Checkbox
                      style={{
                        color: clusterMapView
                          ? corrChartColors[tt].color
                          : '#AAA',
                      }}
                      checked={x}
                      value={tt}
                      onChange={e => handleCBChange(e)}
                      name="Clusters"
                      disabled={!clusterMapView}
                    />
                  }
                  label={<Typography className={classes.formControlLabel}>{`Cluster ${tt + 1}`}</Typography>}
                />
              </Grid>
            </div>
          ))}
        </Grid>
      </div>
    </div>
  );
};

ClusterViewSelector.propTypes = {
  clustersVisible: PropTypes.bool,
  setClustersVisible: PropTypes.func,
  clusterMapView: PropTypes.bool,
};


export default ClusterViewSelector;
